import CubeIcon from "../icons/CubeIcon";
import { filter, flexAlign, flexJustify, opacity } from "./functions";

export default function LogoLayer ({layer}) {

  return <>
    <div
      className='absolute-full logo-preview'
      draggable="false"
      style={{
        userSelect:     'none',
        fontWeight:     900,
        fontSize:       '4rem',
        lineHeight:     '0rem',
        padding:        '1.5rem 3rem',
        color:          layer.color ?? '#333',
        opacity:        opacity(layer),
        background:     (layer.color ? '': '#EEEEEEF3'),
        outline:        (layer.color ? '': '1px solid #AAAAAA'),
        display:        'flex',
        alignItems:     flexAlign(layer),
        justifyContent: flexJustify(layer),
        overflow:       'hidden',
        filter:         filter(layer),
      }}
    >
      <div className='flex flex-center gap-2'>
        <span style={{transform: 'scale(3)', transformOrigin: 'center right'}}><CubeIcon solid/></span>
        LOGO
        <span style={{transform: 'scale(3)', transformOrigin: 'center left'}}><CubeIcon solid/></span>
      </div>
    </div>
  </>
}
